import { Flex, type FlexProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export function ScalableInteractive({
   children,
   ...flexProps
}: { children: ReactNode } & FlexProps) {
   return (
      <Flex
         transition="transform 0.1s"
         _active={{
            transform: 'scale(1.05)',
         }}
         {...flexProps}
      >
         {children}
      </Flex>
   );
}
